module.exports = __webpack_public_path__ + "img/company-size.41aaec5.svg";